import React from 'react';
import { useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase.init';
import usePosts from '../../hooks/usePosts';
import useUser from '../../hooks/useUser';
import useUsers from '../../hooks/useUsers';
import SinglePost from '../Feed/SinglePost';

const MyPosts = ({ id }) => {

    const [users] = useUsers();
    const [posts] = usePosts();
    const [user, loading] = useAuthState(auth);
    const [userc] = useUser(user?.email);

    posts?.sort((a, b) => new Date(b?.date) - new Date(a?.date));

    // const [interest, setInterest] = useState(false);
    // const getInterest = (post) => {
    //     if (post?.interested?.find(i => i?.id === userc?._id) !== undefined) {
    //         setInterest(true);
    //     }
    //     return interest;
    // }
    // const myPost = posts.filter(post => post?.uid === id || getInterest(post));
    const myPost = posts.filter(post => post?.uid === id);

    return (
        myPost.length === 0 ? (
            <div className='text-lg'>
                <p>No Posts Available.</p>
            </div>
        ) : (
            <div>
                {
                    myPost?.map(post => (
                        <SinglePost key={post?._id} id={post?._id} />
                    ))
                }
            </div >
        )
    );
};

export default MyPosts;